"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var SearchLoupeIcon16Light_1 = require("./SearchLoupeIcon16Light");
var SearchLoupeIcon16Regular_1 = require("./SearchLoupeIcon16Regular");
var SearchLoupeIcon16Solid_1 = require("./SearchLoupeIcon16Solid");
var SearchLoupeIcon20Light_1 = require("./SearchLoupeIcon20Light");
var SearchLoupeIcon20Regular_1 = require("./SearchLoupeIcon20Regular");
var SearchLoupeIcon20Solid_1 = require("./SearchLoupeIcon20Solid");
var SearchLoupeIcon24Regular_1 = require("./SearchLoupeIcon24Regular");
var SearchLoupeIcon24Solid_1 = require("./SearchLoupeIcon24Solid");
var SearchLoupeIcon32Regular_1 = require("./SearchLoupeIcon32Regular");
var SearchLoupeIcon64Regular_1 = require("./SearchLoupeIcon64Regular");
var sizes = {
    16: {
        light: SearchLoupeIcon16Light_1.SearchLoupeIcon16Light,
        regular: SearchLoupeIcon16Regular_1.SearchLoupeIcon16Regular,
        solid: SearchLoupeIcon16Solid_1.SearchLoupeIcon16Solid,
    },
    20: {
        light: SearchLoupeIcon20Light_1.SearchLoupeIcon20Light,
        regular: SearchLoupeIcon20Regular_1.SearchLoupeIcon20Regular,
        solid: SearchLoupeIcon20Solid_1.SearchLoupeIcon20Solid,
    },
    24: {
        regular: SearchLoupeIcon24Regular_1.SearchLoupeIcon24Regular,
        solid: SearchLoupeIcon24Solid_1.SearchLoupeIcon24Solid,
    },
    32: {
        regular: SearchLoupeIcon32Regular_1.SearchLoupeIcon32Regular,
    },
    64: {
        regular: SearchLoupeIcon64Regular_1.SearchLoupeIcon64Regular,
    },
};
exports.SearchLoupeIcon = forwardRef_1.forwardRef('SearchLoupeIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
